import { useEffect, useState } from 'react';
import ReactModal from 'react-modal';

import { useModal } from 'context/ModalContext';

import { Colaboracao, FocoNoCliente, Inovacao, MandouBem, Lideranca, Uau, Valeu } from 'components/icons';
import { FaTimes, FaPlus, FaEquals } from 'react-icons/fa';
import { IoIosClose } from 'react-icons/io';
import { nivelByMoeda } from 'components/rebrand/mappings';

const iconSize = 40;
const ComportamentoIcon: any = {
  cooperacao: <Colaboracao size={iconSize} />,
  iniciativa: <Inovacao size={iconSize} />,
  integridade: <FocoNoCliente size={iconSize} />,
  lideranca: <Lideranca size={iconSize} />,
};

const Comportamento: any = {
  cooperacao: 50,
  iniciativa: 50,
  integridade: 50,
  lideranca: 50,
};

const ComportamentoLabel: any = {
  cooperacao: 'Cooperação',
  iniciativa: 'Iniciativa',
  integridade: 'Integridade',
  lideranca: 'Liderança Inspiradora',
};

const Multiplicador: any = {
  '3': 'Meu Gestor',
  '2': 'Diretor',
  '1.5': 'Executivo',
  '1.3': 'Gerente de Soluções',
  '1.2': 'Gerente de Equipe',
  '1': 'Demais funções',
};

const Moeda: any = {
  uau: 50,
  mandou: 30,
  valeu: 10,
};

const MoedaLabel: any = {
  uau: 'Arrasou',
  mandou: 'Top',
  valeu: 'Curti',
};

const MoedaIcon: any = {
  uau: <Uau yellow size={iconSize} />,
  mandou: <MandouBem yellow size={iconSize} />,
  valeu: <Valeu yellow size={iconSize} />,
};

const Proximidade: any = {
  '40': 'Mesma equipe',
  '25': 'Mesma Diretoria',
  '15': 'Diretoria Diferente',
};

export function ExtratoDetalheModal(props: any) {
  // const modalID = "achievement";

  const modalID = 'extrato-detalhe';

  const [modalIsOpen, setIsOpen] = useState(false);

  const { openModal, modalData, closeModal } = useModal();

  ReactModal.setAppElement('#modal');

  function handleCloseModal() {
    //
  }

  function afterOpenModal() {
    //
  }

  useEffect(() => {
    setIsOpen(openModal === modalID);
  }, [openModal]);

  useEffect(() => {
    if (!modalIsOpen) return;
  }, [modalIsOpen, modalData]);

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Detalhe do reconhecimento"
        portalClassName="relative z-50"
        overlayClassName="rb-modal-overlay"
        contentElement={() => (
          <>
            {modalIsOpen && modalData && (
              <div className="rb-modal rb-modal--lg">
                <button className="rb-modal__close" aria-label="Fechar" onClick={() => closeModal()}>
                  <IoIosClose size={26} />
                </button>

                <div className="rb-modal__header">
                  <h1 className="rb-modal__title">Reconhecimento enviado por</h1>
                  <p className="rb-modal__subtitle">
                    {modalData.sender_name} · {new Date(modalData.time).toLocaleString()}
                  </p>
                </div>

                <div className="rb-calc">
                  <div className="rb-calc__card">
                    <span className="rb-calc__icon">{ComportamentoIcon[modalData.behavior]}</span>
                    <span className="rb-calc__label">{ComportamentoLabel[modalData.behavior]}</span>
                    <span className="rb-calc__value">{Comportamento[modalData.behavior]}</span>
                  </div>

                  <FaPlus size={18} className="rb-calc__op" />

                  <div className="rb-calc__card">
                    <span className="rb-calc__icon">{MoedaIcon[modalData.coin]}</span>
                    <span className="rb-calc__label">{nivelByMoeda(modalData.coin).tag}</span>
                    <span className="rb-calc__value">{Moeda[modalData.coin]}</span>
                  </div>

                  <FaPlus size={18} className="rb-calc__op" />

                  <div className="rb-calc__card">
                    <span className="rb-calc__hint">Proximidade</span>
                    <span className="rb-calc__label">{Proximidade[`${modalData.proximidade}`]}</span>
                    <span className="rb-calc__value">{modalData.proximidade}</span>
                  </div>

                  <FaTimes size={18} className="rb-calc__op" />

                  <div className="rb-calc__card">
                    <span className="rb-calc__hint">Função</span>
                    <span className="rb-calc__label">{modalData.sender_funcao}</span>
                    <span className="rb-calc__value">{modalData.hierarquia}</span>
                  </div>

                  <FaEquals size={18} className="rb-calc__op" />

                  <div className="rb-calc__card rb-calc__card--total">
                    <span className="rb-calc__label">Total de estrelas</span>
                    <span className="rb-calc__value">{modalData.total}</span>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      />
    </>
  );
}
